import { CogoLogoBrand } from "@/components/cogo-logo"
import type { CSSProperties } from "react"

export interface CogoMarkProps {
  size?: number
  variant?: "default" | "speed"
  className?: string
  style?: CSSProperties
}

/**
 * CogoMark — IDE brand symbol.
 * Delegates to the unified CogoLogoBrand to eliminate duplicate vector paths.
 */
export function CogoMark({ size = 24, variant = "speed", className, style }: CogoMarkProps) {
  return (
    <CogoLogoBrand
      size={size}
      variant={variant === "speed" ? "speed" : "default"}
      className={className}
      style={style}
    />
  )
}
